import { MessageCarousel } from '@/components/MessageCarousel';
import { CarouselPart, TextPart } from '@/sharedType';
import { cn } from '@/utils';
import { t } from 'i18next';
import { ReactNode } from 'react';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import remarkGfm from 'remark-gfm';

const ERROR_MSG = t('errors.generalError');

function SimpleMarkdown({
  markdown,
  isUser,
  customUserText,
}: {
  customUserText?: string;
  isUser: boolean;
  markdown: string;
}) {
  return (
    <ReactMarkdown
      className="p-3"
      remarkPlugins={[remarkGfm]}
      components={{
        li: ({ children }) => <li data-md-li>{children}</li>,
        p: ({ children }) => (
          <p
            className="wrap-break-word my-2 first:mt-0 last:mb-0"
            style={isUser && customUserText ? { color: customUserText } : undefined}
          >
            {children}
          </p>
        ),
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noopener noreferrer" className="inline-block">
            <span className={cn('font-medium', isUser ? 'text-gray-600 ' : 'text-purple-600')}>
              {children}
            </span>
          </a>
        ),
        img: ({ src, alt }) => <img src={src} alt={alt || ''} className="rounded-md my-8" />,
      }}
    >
      {markdown}
    </ReactMarkdown>
  );
}
export function StructuredMessage({
  markdown,
  markdownList,
  carouselPart,
  isUser,
  customUserText,
}: {
  customUserText?: string;
  isUser: boolean;
  markdown: string;
  markdownList: TextPart[];
  carouselPart: CarouselPart[];
}) {
  // simple messages
  if (markdown) {
    return <SimpleMarkdown markdown={markdown} isUser={isUser} customUserText={customUserText} />;
  } else if (markdownList.length || carouselPart.length) {
    const list: ReactNode[] = [];

    const combinedList = [...markdownList, ...carouselPart];

    combinedList.forEach((e, index) => {
      if (e.type === 'text') {
        list.push(
          <SimpleMarkdown
            key={`${e.priority}${index}`}
            markdown={e.text}
            isUser={isUser}
            customUserText={customUserText}
          />,
        );
      } else if (e.type === 'carousel') {
        list.push(<MessageCarousel key={`${e.priority}${index}`} list={e.images} />);
      }
    });
    return <div className="max-w-md">{list}</div>;
  } else {
    return <SimpleMarkdown markdown={ERROR_MSG} isUser={isUser} customUserText={customUserText} />;
  }
}
